import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../service/UserService';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { User } from '../shared/models/user'; 

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  hide = true;
  error = "";
  contador = 0;
  showForgotPassword = false;
  loading = false;
  loadingRegister = false;
  message = '';
  textColor: string = 'blue';
  email: string = '';

  private readonly WELCOME_PROMO_CODE_ID = 'NEW-CLIENT';

  constructor(
    private router: Router,
    private userService: UserService,
    private http: HttpClient
  ) {}

  ngOnInit(): void {}

  contactForm = new FormGroup({
    email: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    phone: new FormControl('', Validators.required) // nuevo campo phone para registro
  });

  toggleForgotPassword(): void {
    this.showForgotPassword = !this.showForgotPassword;
  }

  // Valida que email y password estén llenos (para Login)
  isLoginFormInvalid(): boolean {
    const email = this.contactForm.get('email');
    const password = this.contactForm.get('password');
    return !email?.value || !password?.value;
  }

  // Valida que email, password y phone estén llenos (para Registro)
  isRegisterFormInvalid(): boolean {
    const email = this.contactForm.get('email');
    const password = this.contactForm.get('password');
    const phone = this.contactForm.get('phone');
    return !email?.value || !password?.value || !phone?.value;
  }

  resetPassword() {
    if (!this.email) {
      alert('Por favor, ingrese su correo electrónico.');
      return;
    }
    this.loading = true;
    this.userService.resetPassword(this.email).subscribe(
      (response: any) => {
        this.loading = false;
        this.message = 'Enlace de restablecimiento enviado a su correo electrónico.';
      },
      (error) => {
        this.loading = false;
        this.message = 'Hubo un error al intentar restablecer la contraseña.';
      }
    );
  }

  onLogin(): void {
    const { email, password } = this.contactForm.value;
    const emailStr = email || '';
    const passwordStr = password || '';

    this.loading = true;
    this.userService.login(emailStr, passwordStr)
      .then(response => {
        this.validationLogin(response.data.token);
        localStorage.setItem('token', response.data.token);
        this.loading = false;
        this.router.navigate(['/product']);
      })
      .catch(error => {
        this.contactForm.reset();
        this.error = "Usuario o contraseña incorrecto";
        this.loading = false;
      });
  }

  register(): void {
    if (this.contactForm.invalid) {
    this.contactForm.markAllAsTouched();
    this.error = "Por favor, completa todos los campos obligatorios.";
    this.message = ""; // Limpiamos mensajes previos de éxito
    return;
  }
    const { email, password, phone } = this.contactForm.value;
    const emailStr = email || '';
    const passwordStr = password || '';
    const phoneStr = phone || '';

    this.loadingRegister = true;
    this.userService.register(emailStr, passwordStr)
      .then(async (response) => {
        localStorage.setItem('token', response.data.token);
        const userValidationResponse = await this.userService.validationLogin(response.data.token);
        const user = userValidationResponse.data;
        localStorage.setItem('cliente', JSON.stringify(user));

        const newUser: User = {
          id: user.uid,
          email: emailStr,
          user: user.uid,
          phone: phoneStr // guardar telefono en el microservicio
        };

        this.userService.addUser(newUser).subscribe({
          next: (addResponse) => {
            console.log('Usuario agregado al microservicio:', addResponse);
            this.userService.saveUserPromotion(user.uid, emailStr, this.WELCOME_PROMO_CODE_ID)
              .subscribe({
                next: () => {
                  console.log('Cupón guardado con éxito.');
                  this.message = '¡Registro exitoso! ¡Ya puedes usar tu cupón de bienvenida!';
                  this.textColor = 'green';
                },
                error: (error: HttpErrorResponse) => {
                  if (error.status === 409) {
                    this.message = '¡Registro exitoso! Tu cupón de bienvenida ya estaba en tu cuenta.';
                    this.textColor = 'green';
                  } else if (error.status === 200 && error.error instanceof ProgressEvent) {
                    this.message = '¡Registro exitoso! ¡Ya puedes usar tu cupón de bienvenida!';
                    this.textColor = 'green';
                  } else {
                    console.error('Error al guardar el cupón', error);
                    this.message = '¡Registro exitoso! Pero no se pudo guardar tu cupón. Intenta más tarde.';
                    this.textColor = 'red';
                  }
                },
                complete: () => {
                  this.loadingRegister = false;
                  setTimeout(() => {
                    this.router.navigate(['/cuenta']);
                  }, 3000);
                }
              });
          },
          error: (addError) => {
            console.error('Error al agregar usuario al microservicio:', addError);
            this.message = '¡Registro exitoso! Pero no se pudo guardar la información del usuario.';
            this.textColor = 'red';
            this.loadingRegister = false;
            setTimeout(() => {
              this.router.navigate(['/home']);
            }, 3000);
          }
        });
      })
      .catch(error => {
        this.contactForm.reset();
        this.error = "Ya se encuentra registrada esa cuenta.";
        this.message = '';
        this.loadingRegister = false;
      });
  }

  validationLogin(token: string) {
    this.userService.validationLogin(token)
      .then(response => {
        localStorage.setItem('cliente', JSON.stringify(response.data));
        const userStr = sessionStorage.getItem('cliente');
        if (userStr) {
          const user = JSON.parse(userStr);
        }
      })
      .catch(error => {
        this.error = "No estas logeado";
      });
  }

  private getErrorMnsFromError(err: any) {
    if (err && err.error) {
      let errorObject: any;
      if (typeof err.error == 'string') {
        try {
          errorObject = JSON.parse(err.error);
        } catch (ex) {
          // This is intentional
        }
      } else if (typeof err.error == 'object') {
        errorObject = err.error;
      }
      if (errorObject && errorObject.localizedMessage) {
        return errorObject.localizedMessage;
      }
    }
    return '';
  }
}
